/*
  Mattress Quiz — logic for sections/mattress-quiz.liquid
  Upload as: Online Store > Themes > Edit code > Assets > Add a new asset > mattress-quiz.js

  Reads its settings and products from the JSON blocks the section prints:
    [data-mq-config]   section settings
    [data-mq-products] mattresses from the chosen collection
*/
(function () {
  'use strict';

  function initQuiz(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';

    var cfg = JSON.parse(root.querySelector('[data-mq-config]').textContent);
    var products = [];
    try { products = JSON.parse(root.querySelector('[data-mq-products]').textContent) || []; } catch (e) {}

    var SIZES = (cfg.sizes || []).map(function (s) { return s.trim(); }).filter(Boolean);
    /* Three price limits make four budget options: below L1, L1-L2, L2-L3, above L3 */
    var LIMITS = [Number(cfg.budgetLow) || 40000, Number(cfg.budgetMid) || 70000, Number(cfg.budgetHigh) || 150000]
      .sort(function (a, b) { return a - b; });
    var fmt = function (n) { return Number(n).toLocaleString('en-US'); };

    /* ---------- Spring or foam: from the store setting, or detected from the product name/type ---------- */
    function kindOf(p, storeType) {
      if (storeType === 'spring' || storeType === 'foam') return storeType;
      var text = [p.title, p.product_type || '', [].concat(p.tags || []).join(' ')].join(' ');
      return /spring|pocket|coil|bonnell/i.test(text) ? 'spring' : 'foam';
    }
    /* ---------- Feel: from the "Feel of each mattress" setting, otherwise guessed from the name ---------- */
    var FEEL_VAL = { 'soft': 1, 'medium-soft': 2, 'medium soft': 2, 'medium-firm': 3, 'medium firm': 3, 'firm': 4, 'extra firm': 4 };
    var FEEL_LABEL = { 1: 'Soft', 2: 'Medium-soft', 3: 'Medium-firm', 4: 'Firm' };
    function cleanName(x) { return String(x).toLowerCase().replace(/[™®©]/g, '').replace(/\s+/g, ' ').trim(); }
    var FEEL_MAP = {};
    String(cfg.feelMap || '').split(/\r?\n/).forEach(function (line) {
      var i = line.lastIndexOf(':');
      if (i < 1) return;
      var vals = line.slice(i + 1).split(/[,\/]/).map(function (f) { return FEEL_VAL[f.trim().toLowerCase()]; }).filter(Boolean);
      if (vals.length) FEEL_MAP[cleanName(line.slice(0, i))] = vals;
    });
    function guessFeel(title) {
      var t = String(title);
      if (/extra firm|ortho|ortica|spine|wonder back|support/i.test(t)) return [4];
      if (/medium[- ]?firm/i.test(t)) return [3];
      if (/medium[- ]?soft|pillow ?top|euro ?top|memory/i.test(t)) return [2];
      if (/plush|soft/i.test(t)) return [1];
      return [];
    }
    function feelsOf(p) { return FEEL_MAP[cleanName(p.title)] || guessFeel(p.title); }

    products.forEach(function (p) { p.brand = cfg.mainName || ''; p.kind = kindOf(p, cfg.mainType); p.feels = feelsOf(p); });

    function money(cents) {
      var f = String(cfg.moneyFormat || 'Rs.{{amount}}').replace(/<[^>]*>/g, '');
      var n = cents / 100;
      var two = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      var none = Math.round(n).toLocaleString('en-US');
      return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
        if (k === 'amount_no_decimals') return none;
        if (k === 'amount_with_comma_separator') return two.replace(/,/g, '.').replace(/\.(\d{2})$/, ',$1');
        if (k === 'amount_no_decimals_with_comma_separator') return none.replace(/,/g, '.');
        return two;
      });
    }

    /* ---------- Second store (e.g. DolceVita), loaded live ---------- */
    var S2 = cfg.store2 || {};
    var store2Ready = Promise.resolve([]);
    if (S2.enabled && S2.url) {
      var s2base = String(S2.url).trim().replace(/\/+$/, '');
      var s2coll = String(S2.collection || '').trim();

      /* Option A: official Shopify Storefront API (used when an access token is set) */
      var gidNum = function (g) { return String(g).split('/').pop(); };
      var loadViaApi = function () {
        var endpoint = s2base + '/api/' + (S2.apiVersion || '2026-04') + '/graphql.json';
        var fields = 'pageInfo { hasNextPage endCursor } nodes { id title handle productType tags onlineStoreUrl ' +
          'featuredImage { url(transform: { maxWidth: 700 }) } ' +
          'variants(first: 50) { nodes { id title availableForSale price { amount } compareAtPrice { amount } } } }';
        var query = s2coll
          ? 'query Quiz($handle: String!, $cursor: String) { collection(handle: $handle) { products(first: 100, after: $cursor) { ' + fields + ' } } }'
          : 'query Quiz($cursor: String) { products(first: 100, after: $cursor) { ' + fields + ' } }';
        var all = [];
        var page = function (cursor) {
          return fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Shopify-Storefront-Access-Token': S2.token },
            body: JSON.stringify({ query: query, variables: s2coll ? { handle: s2coll, cursor: cursor } : { cursor: cursor } })
          }).then(function (r) { if (!r.ok) throw new Error('Storefront API HTTP ' + r.status); return r.json(); })
            .then(function (j) {
              if (j.errors && !j.data) throw new Error('Storefront API: ' + (j.errors[0] && j.errors[0].message));
              var conn = s2coll ? (j.data.collection && j.data.collection.products) : j.data.products;
              if (!conn) throw new Error('Storefront API: collection "' + s2coll + '" not found');
              conn.nodes.forEach(function (n) {
                all.push({
                  id: gidNum(n.id), title: n.title, handle: n.handle, product_type: n.productType, tags: n.tags || [],
                  url: n.onlineStoreUrl || null,
                  images: n.featuredImage ? [{ src: n.featuredImage.url, sized: true }] : [],
                  variants: (n.variants.nodes || []).map(function (v) {
                    return { id: gidNum(v.id), title: v.title, available: v.availableForSale, price: v.price.amount, compare_at_price: v.compareAtPrice ? v.compareAtPrice.amount : null };
                  })
                });
              });
              return conn.pageInfo.hasNextPage && all.length < 1000 ? page(conn.pageInfo.endCursor) : all;
            });
        };
        return page(null);
      };

      /* Option B: public products.json feed (no token needed; also the backup if the API fails) */
      var loadViaJson = function () {
        var path = s2coll ? '/collections/' + encodeURIComponent(s2coll) + '/products.json?limit=250' : '/products.json?limit=250';
        return fetch(s2base + path, { headers: { Accept: 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error('products.json HTTP ' + r.status); return r.json(); })
          .then(function (j) { return j.products || []; });
      };

      var source = S2.token
        ? loadViaApi().catch(function (e) { if (window.console) console.warn('Mattress quiz: Storefront API failed, using products.json instead.', e); return loadViaJson(); })
        : loadViaJson();

      store2Ready = source
        .then(function (raw) {
          var list = raw.filter(function (p) {
            return !/pillow|protector|topper|bed sheet|accessor/i.test((p.product_type || '') + ' ' + (p.tags || []).join(' '));
          }).map(function (p) {
            var vs = (p.variants || []).map(function (v) {
              var c = Math.round(parseFloat(v.price) * 100);
              var cmp = v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : 0;
              return { id: v.id, title: v.title, available: v.available !== false, price: c, priceText: money(c), compareText: cmp > c ? money(cmp) : null };
            });
            var low = vs.slice().sort(function (a, b) { return a.price - b.price; })[0] || { price: 0, priceText: '', compareText: null };
            var img = p.images && p.images[0] ? p.images[0].src : null;
            if (img && !p.images[0].sized) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=700';
            return {
              id: 's2-' + p.id, title: p.title, url: p.url || (s2base + '/products/' + p.handle), image: img,
              price: low.price, priceText: low.priceText, compareText: low.compareText,
              available: vs.some(function (v) { return v.available; }),
              tags: Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(','),
              variants: vs, external: true, brand: S2.name || '', kind: kindOf(p, S2.type), feels: feelsOf(p)
            };
          });
          return list;
        })
        .catch(function (e) { if (window.console) console.warn('Mattress quiz: could not load second store products', e); return []; });
    }

    /* ---------- Icons (original line drawings) ---------- */
    var dots = function (pts) { return pts.map(function (p) { return '<circle class="k" cx="' + p[0] + '" cy="' + p[1] + '" r="1.3" stroke="none"/>'; }).join(''); };
    var bill = function (x, y) {
      return '<rect class="w" x="' + x + '" y="' + y + '" width="50" height="28" rx="2"/>' +
        '<rect class="l" x="' + (x + 4) + '" y="' + (y + 4) + '" width="42" height="20" rx="1.5"/>' +
        '<circle class="w" cx="' + (x + 25) + '" cy="' + (y + 14) + '" r="7"/>' +
        '<path d="M' + (x + 27.5) + ' ' + (y + 10.5) + 'c-1-1-5-1.4-5 1s5 1.4 5 3.6-4 2.2-5.4 .8M' + (x + 25) + ' ' + (y + 8.5) + 'v11"/>';
    };
    var pillowHead = function (headClass) {
      return '<rect class="l" x="12" y="12" width="56" height="24" rx="9"/><circle class="' + headClass + '" cx="40" cy="25" r="9"/>';
    };
    var ICONS = {
      spring: '<path d="M14 14l14 6-14 6 14 6-14 6 14 6-14 6 14 6-14 6"/><path d="M33 14l14 6-14 6 14 6-14 6 14 6-14 6 14 6-14 6"/><path d="M52 14l14 6-14 6 14 6-14 6 14 6-14 6 14 6-14 6"/>',
      foam: '<rect class="w" x="12" y="16" width="56" height="48" rx="6"/><path class="l" d="M12 42c9-6 19 6 28 0s19 6 28 0v16a6 6 0 01-6 6H18a6 6 0 01-6-6z"/>' +
        dots([[22, 24], [32, 24], [42, 24], [52, 24], [60, 24], [27, 31], [37, 31], [47, 31], [57, 31], [22, 52], [32, 54], [42, 52], [52, 54], [60, 52]]),
      unsure: '<path d="M31 30a9 9 0 1118 0c0 7-9 8-9 15" stroke-width="2.4"/><circle class="k" cx="40" cy="55" r="2.2" stroke="none"/>',
      side: pillowHead('w') + '<path class="w" d="M30 40c-6 8-6 18 2 26h20c4-6 4-14-2-20l-6-6z"/><path d="M36 22h2"/>',
      back: pillowHead('w') + '<path class="w" d="M24 68V48a10 10 0 0110-10h12a10 10 0 0110 10v20"/><path d="M36 24h.5M44 24h.5M37 29c2 1.5 4 1.5 6 0"/>',
      stomach: pillowHead('k') + '<path class="w" d="M24 68V48a10 10 0 0110-10h12a10 10 0 0110 10v20"/><path d="M40 42v24" stroke-dasharray="2 4"/>',
      varies: pillowHead('w') + '<path class="w" d="M28 68V50a8 8 0 018-8h8a8 8 0 018 8v18"/><path d="M16 50c-4 6-2 12 3 16"/><path d="M15 61l4 5 4-4"/><path d="M64 50c4 6 2 12-3 16"/><path d="M65 61l-4 5-4-4"/>',
      money1: bill(15, 26),
      money2: bill(10, 32) + bill(20, 22),
      money3: bill(8, 36) + bill(15, 28) + bill(22, 20),
      money4: bill(4, 42) + bill(10, 34) + bill(16, 26) + bill(22, 18)
    };
    /* Your own icon URLs. An image uploaded in the section settings overrides these. */
    var ICON_URLS = {
      side: 'https://care.diamondfoam.com/media//wysiwyg/warranty-form-images/side.png',
      back: 'https://care.diamondfoam.com/media//wysiwyg/warranty-form-images/back.png',
      stomach: 'https://care.diamondfoam.com/media//wysiwyg/warranty-form-images/stomach.png',
      varies: 'https://care.diamondfoam.com/media//wysiwyg/warranty-form-images/it-varies.png'
    };
    var UPLOADED = {};
    Object.keys(ICONS).forEach(function (k) { UPLOADED[k] = (cfg.icons || {})[k] || ICON_URLS[k] || null; });
    function iconSvg(name) {
      var src = UPLOADED[name];
      if (src) return '<img src="' + String(src).replace(/"/g, '&quot;') + '" alt="" loading="lazy">';
      return '<svg class="mq-ic" viewBox="0 0 80 80" aria-hidden="true">' + (ICONS[name] || '') + '</svg>';
    }

    /* ---------- The 5 questions (edit wording here) ---------- */
    var QUESTIONS = [
      { id: 'size', style: 'pills', title: 'What size mattress do you need?',
        desc: 'We will only show mattresses available in this size.',
        options: SIZES.map(function (s) { return { v: s, label: s }; }) },
      { id: 'type', style: 'tiles', title: 'Spring or foam?',
        desc: 'Spring mattresses feel bouncy and airy. Foam mattresses hug your body and absorb movement.',
        options: [{ v: 'spring', label: 'Spring', icon: 'spring' }, { v: 'foam', label: 'Foam', icon: 'foam' }, { v: 'unsure', label: 'Not Sure', icon: 'unsure' }] },
      { id: 'feel', style: 'pills', title: 'How do you want your mattress to feel?',
        desc: 'Choose the comfort level you like, from soft and plush to firm, or somewhere in between.',
        options: [{ v: 'soft', label: 'Soft' }, { v: 'medium-soft', label: 'Medium-Soft' }, { v: 'medium-firm', label: 'Medium-Firm' }, { v: 'firm', label: 'Firm' }] },
      { id: 'position', style: 'tiles', title: 'What is your usual sleep position?',
        desc: 'Your sleep position tells us how much support and pressure relief your body needs.',
        options: [{ v: 'side', label: 'Side', icon: 'side' }, { v: 'back', label: 'Back', icon: 'back' }, { v: 'stomach', label: 'Stomach', icon: 'stomach' }, { v: 'varies', label: 'It Varies', icon: 'varies' }] },
      { id: 'budget', style: 'tiles', title: 'How much are you looking to spend?',
        desc: 'Your budget helps us narrow down to mattresses that give you the best value.',
        options: [
          { v: '0', label: 'Less than ' + fmt(LIMITS[0]), icon: 'money1' },
          { v: '1', label: fmt(LIMITS[0] + 1000) + ' - ' + fmt(LIMITS[1]), icon: 'money2' },
          { v: '2', label: fmt(LIMITS[1] + 1000) + ' - ' + fmt(LIMITS[2]), icon: 'money3' },
          { v: '3', label: fmt(LIMITS[2]) + '+', icon: 'money4' }
        ] }
    ];
    if (!SIZES.length) QUESTIONS = QUESTIONS.filter(function (q) { return q.id !== 'size'; });

    var STEPS = ['intro'].concat(QUESTIONS.map(function (q) { return q.id; }));
    if (cfg.lead) STEPS.push('lead');
    STEPS.push('results');

    /* ---------- State & helpers ---------- */
    var stage = root.querySelector('[data-stage]');
    var bar = root.querySelector('[data-progress]');
    var introTpl = root.querySelector('[data-intro-template]');
    var leadWrap = root.querySelector('[data-lead-wrap]');
    var leadForm = root.querySelector('[data-lead]');
    var step = 0;
    var answers = {};
    var thanksName = null;
    var leadData = null;          /* name / phone / email entered on the details step */
    var lastSheetRow = null;      /* avoids saving the same quiz twice */
    var PENDING_KEY = 'mattress-quiz-pending-' + root.id;

    function h(tag, props, kids) {
      var n = document.createElement(tag);
      if (props) Object.keys(props).forEach(function (k) {
        if (k === 'text') n.textContent = props[k];
        else if (k === 'html') n.innerHTML = props[k];
        else if (k === 'on') Object.keys(props.on).forEach(function (ev) { n.addEventListener(ev, props.on[ev]); });
        else if (props[k] !== null && props[k] !== undefined) n.setAttribute(k, props[k]);
      });
      (kids || []).forEach(function (c) { if (c) n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
      return n;
    }
    function answered(id) { var a = answers[id]; return Array.isArray(a) ? a.length > 0 : a !== undefined; }
    function questionById(id) { return QUESTIONS.filter(function (q) { return q.id === id; })[0]; }
    function labelFor(qid, v) { var q = questionById(qid); var o = q && q.options.filter(function (x) { return x.v === v; })[0]; return o ? o.label : v; }

    function go(n) {
      step = Math.max(0, Math.min(n, STEPS.length - 1));
      if (leadWrap && leadForm.parentNode !== leadWrap) { leadWrap.appendChild(leadForm); }
      stage.innerHTML = '';
      var id = STEPS[step];
      if (id === 'intro') renderIntro();
      else if (id === 'lead') { done = false; stage.appendChild(leadForm); }
      else if (id === 'results') renderResults();
      else renderQuestion(questionById(id));
      var lastQ = STEPS.length - (cfg.lead ? 3 : 2);
      bar.style.width = (id === 'results' || id === 'lead' ? 100 : (step / lastQ) * 100) + '%';
      if (id !== 'intro') {
        var t = stage.querySelector('.mq-q');
        if (t) t.focus({ preventScroll: true });
        var card = root.querySelector('.mq-card'), box = card.getBoundingClientRect();
        if (box.top < 0 || box.bottom > window.innerHeight) card.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function renderIntro() {
      var wrap = h('div', { class: 'mq-step' });
      wrap.innerHTML = introTpl.innerHTML;
      wrap.appendChild(h('h2', { class: 'mq-q', tabindex: '-1', text: cfg.introTitle }));
      if (cfg.introText) wrap.appendChild(h('p', { class: 'mq-desc', text: cfg.introText }));
      wrap.appendChild(h('button', { type: 'button', class: 'mq-btn', text: cfg.startLabel || 'Start your Quiz', on: { click: function () { go(1); } } }));
      stage.appendChild(wrap);
    }

    function renderQuestion(q) {
      var isLastQ = STEPS[step + 1] === 'results' || STEPS[step + 1] === 'lead';
      var nextBtn = h('button', { type: 'button', class: 'mq-btn', text: isLastQ ? 'Submit' : 'Next' });
      nextBtn.disabled = !answered(q.id);
      nextBtn.addEventListener('click', function () { if (!nextBtn.disabled) go(step + 1); });

      var shortLabels = q.options.every(function (o) { return o.label.length <= 16; });
      var list = h('div', { class: q.style === 'tiles' ? 'mq-tiles cols-' + q.options.length : 'mq-pills' + (shortLabels ? ' is-short' : ''), role: 'group', 'aria-label': q.title });
      q.options.forEach(function (o) {
        var cur = answers[q.id];
        var on = q.multi ? (cur || []).indexOf(o.v) > -1 : cur === o.v;
        var btn = q.style === 'tiles'
          ? h('button', { type: 'button', class: 'mq-tile', 'aria-pressed': String(on) }, [h('span', { class: 'mq-tile__box', html: iconSvg(o.icon) }), h('span', { text: o.label })])
          : h('button', { type: 'button', class: 'mq-pill', 'aria-pressed': String(on), text: o.label });
        btn.addEventListener('click', function () {
          if (q.multi) {
            var arr = (answers[q.id] || []).slice();
            var i = arr.indexOf(o.v);
            if (i > -1) arr.splice(i, 1); else arr.push(o.v);
            answers[q.id] = arr;
            btn.setAttribute('aria-pressed', String(i === -1));
          } else {
            answers[q.id] = o.v;
            Array.prototype.forEach.call(list.children, function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
          }
          nextBtn.disabled = !answered(q.id);
        });
        list.appendChild(btn);
      });

      stage.appendChild(h('div', { class: 'mq-step' }, [
        h('h2', { class: 'mq-q', tabindex: '-1', text: q.title }),
        q.desc ? h('p', { class: 'mq-desc', text: q.desc }) : h('div', { style: 'height:20px' }),
        list,
        h('div', { class: 'mq-nav' }, [
          h('button', { type: 'button', class: 'mq-btn', text: 'Previous', on: { click: function () { go(step - 1); } } }),
          nextBtn
        ])
      ]));
    }

    /* ---------- Matching: size, spring/foam and budget only ---------- */
    /* Size names and the dimensions used in variant titles on both stores (edit if needed) */
    var SIZE_ALIASES = { single: ['78x42'], double: ['72x60'], queen: ['78x60', '78x66'], king: ['78x72'] };
    function norm(x) { return String(x).toLowerCase().replace(/\s+/g, ''); }
    function sizeVariants(p, size) {
      if (!size) return p.variants.slice();
      var s = norm(size), keys = [s].concat(SIZE_ALIASES[s] || []);
      return p.variants.filter(function (v) { var t = norm(v.title); return keys.some(function (k) { return t.indexOf(k) > -1; }); });
    }
    function budgetRange(b) {
      if (b === undefined) return [0, Infinity];
      return [[0, LIMITS[0]], [LIMITS[0], LIMITS[1]], [LIMITS[1], LIMITS[2]], [LIMITS[2], Infinity]][Number(b)] || [0, Infinity];
    }

    /* Returns null when the mattress is not available in the chosen size or is the wrong type. */
    function evaluate(a, p) {
      if (a.type && a.type !== 'unsure' && p.kind !== a.type) return null;
      var vs = sizeVariants(p, a.size).filter(function (v) { return v.available; });
      if (!vs.length) return null;

      var range = budgetRange(a.budget), lo = range[0], hi = range[1], openTop = hi === Infinity;
      var gap = function (v) { var pr = v.price / 100; return pr > hi ? pr - hi : pr < lo ? lo - pr : 0; };
      var inRange = vs.filter(function (v) { return gap(v) === 0; });
      var v, fit;
      if (inRange.length) {
        /* Open-ended budget: start from the lowest price. Capped budget: the best option up to the limit. */
        inRange.sort(function (x, y) { return openTop ? x.price - y.price : y.price - x.price; });
        v = inRange[0]; fit = 'in';
      } else {
        vs.sort(function (x, y) { return gap(x) - gap(y); });
        v = vs[0]; fit = v.price / 100 > hi ? 'above' : 'below';
      }

      /* Feel: 0 = exactly what they asked for, 1 = one step away (or feel unknown), up to 3 */
      /* Sleep position: the feel that usually suits it (1 soft ... 4 firm). Used to break ties between
         mattresses equally close to the chosen feel, and to pick the better side of a two-sided mattress. */
      var posIdeal = { side: 1.5, back: 3, stomach: 3.5, varies: 2.5 }[a.position];
      var want = FEEL_VAL[a.feel], feels = p.feels || [], dist = 0, closest = null, posGap = 2;
      if (feels.length) {
        var target = want || posIdeal;
        if (target) {
          closest = feels.slice().sort(function (f1, f2) {
            return Math.abs(f1 - target) - Math.abs(f2 - target) || (posIdeal ? Math.abs(f1 - posIdeal) - Math.abs(f2 - posIdeal) : 0);
          })[0];
          if (want) dist = Math.abs(closest - want);
          if (posIdeal) posGap = Math.abs(closest - posIdeal);
        }
      } else if (want) dist = 1;

      var why = [];
      if (a.size) why.push('Available in ' + a.size + ' size');
      why.push(p.kind === 'spring' ? 'Spring mattress' : 'Foam mattress');
      if (closest !== null && dist === 0) why.push(FEEL_LABEL[closest] + ' feel, as you asked');
      else if (closest !== null && dist === 1) why.push(FEEL_LABEL[closest] + ' feel, close to what you asked');
      if (closest !== null && posGap <= 0.75) why.push('Suits ' + { side: 'side', back: 'back', stomach: 'stomach', varies: 'combination' }[a.position] + ' sleepers');
      if (fit === 'in') why.push('Within your budget');
      else if (fit === 'below') why.push('Under your budget');
      return { p: p, v: v, fit: fit, gap: gap(v), dist: dist, posGap: posGap, openTop: openTop, why: why, note: fit === 'above' ? 'Slightly above your budget' : null };
    }

    /* Order: affordable mattresses (within or under budget) first, closest feel first, then within budget
       before under budget, then price. Mattresses over budget come last, closest price first. */
    function rank(a, list) {
      var res = list.map(function (p) { return evaluate(a, p); }).filter(Boolean);
      var ok = res.filter(function (r) { return r.fit !== 'above'; }).sort(function (x, y) {
        if (x.dist !== y.dist) return x.dist - y.dist;
        if (x.fit !== y.fit) return x.fit === 'in' ? -1 : 1;
        if (x.posGap !== y.posGap) return x.posGap - y.posGap;
        if (x.fit === 'in') return x.openTop ? x.v.price - y.v.price : y.v.price - x.v.price;
        return x.gap - y.gap;
      });
      var above = res.filter(function (r) { return r.fit === 'above'; }).sort(function (x, y) { return x.gap - y.gap || x.dist - y.dist; });
      return ok.concat(above);
    }

    function summary() {
      return QUESTIONS.map(function (q) {
        var a = answers[q.id];
        if (a === undefined) return null;
        var vals = (Array.isArray(a) ? a : [a]).map(function (v) { return labelFor(q.id, v); });
        return q.title + ' ' + vals.join(', ');
      }).filter(Boolean).join('\n');
    }

    /* ---------- Completion page ---------- */
    /* ---------- Add to cart + open and refresh the theme's cart drawer ---------- */
    var DRAWER_SELECTOR = 'cart-drawer, cart-drawer-component, cart-notification, #CartDrawer, #cart-drawer, #mini-cart, ' +
      '[data-cart-drawer], .cart-drawer, #sidebar-cart, #CartPopup, .js-cart-drawer, [id*="CartDrawer"]';
    var TOGGLE_SELECTOR = '[data-cart-drawer-toggle], [data-drawer-toggle="cart"], .js-drawer-open-cart, [aria-controls*="cart" i], ' +
      '#cart-icon-bubble, .header__icon--cart, a.cart-link, a[href$="/cart"][data-cart-toggle]';
    var COUNT_SELECTOR = '[data-cart-count], .cart-count, .cart-count-bubble span[aria-hidden="true"], #CartCount, .cart-item-count, ' +
      '.header__cart-count, [data-header-cart-count], .js-cart-count';

    function themeDrawer() { return document.querySelector(DRAWER_SELECTOR); }

    /* Aose theme (Diamond Foam): cart lives in window.xoStore, drawer opens with xoModal.open('cart'),
       and the mini cart re-renders from the "xo-cart-mini" section returned by Shopify. */
    function aoseCart() {
      var mini = document.querySelector('xo-cart-mini');
      if (!mini || !window.xoStore || typeof window.xoStore.set !== 'function' || !window.xoModal || typeof window.xoModal.open !== 'function') return null;
      var ids = [];
      var full = document.querySelector('xo-cart');
      if (full && full.id && /\/cart/.test(location.pathname)) ids.push(full.id);
      if (mini.id) ids.push(mini.id);
      return ids.length ? { sections: ids } : null;
    }

    function isDawnDrawer(d) { return d && typeof d.renderContents === 'function' && typeof d.getSectionsToRender === 'function'; }

    function updateCountBubbles(cart) {
      Array.prototype.forEach.call(document.querySelectorAll(COUNT_SELECTOR), function (el) {
        if (el.closest('[data-mattress-quiz]')) return;
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
        var bubble = el.closest('.cart-count-bubble');
        if (bubble) bubble.hidden = cart.item_count === 0;
      });
    }

    function openDrawer(d) {
      if (!d) return false;
      try {
        if (typeof d.open === 'function') { d.open(); return true; }
        if (typeof d.show === 'function') { d.show(); return true; }
        if ('open' in d && typeof d.open === 'boolean') { d.open = true; return true; }
      } catch (e) {}
      var toggle = document.querySelector(TOGGLE_SELECTOR);
      if (toggle && !toggle.closest('[data-mattress-quiz]')) { toggle.click(); return true; }
      d.classList.add('active', 'is-open', 'drawer--is-open', 'is-active');
      d.setAttribute('aria-hidden', 'false');
      return true;
    }

    /* Tell the theme the cart changed, using the events popular themes listen for */
    function announceCartChange(cart, item) {
      var detail = { cart: cart, items: item ? [item] : [], product: item, source: 'mattress-quiz' };
      var fire = function (target, name, d) { try { target.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: d || detail })); } catch (e) {} };
      fire(document, 'cart:update', { resource: cart, sourceId: 'mattress-quiz', data: { itemCount: cart.item_count, source: 'product-form-component' } }); /* Horizon */
      fire(document.documentElement, 'cart:refresh', { cart: cart, openMiniCart: true });  /* Focal, Prestige, Impact, Warehouse */
      fire(document, 'cart:refresh'); fire(document, 'cart:build'); fire(document, 'cart:updated');
      fire(document, 'theme:cart:reload'); fire(document, 'ajaxProduct:added');              /* Impulse, Motion, Streamline */
      fire(document, 'product:added', { variantId: item && item.variant_id, quantity: 1, cart: cart });
    }

    /* Re-render the drawer and cart icon through Shopify's Section Rendering API (theme-independent) */
    function rerenderSections(d) {
      var ids = [];
      var add = function (el) { var sec = el && el.closest('[id^="shopify-section-"]'); if (sec) { var id = sec.id.replace('shopify-section-', ''); if (ids.indexOf(id) === -1) ids.push(id); } };
      add(d);
      Array.prototype.forEach.call(document.querySelectorAll('#cart-icon-bubble, ' + COUNT_SELECTOR), function (el) { if (!el.closest('[data-mattress-quiz]')) add(el); });
      ids = ids.filter(function (id) { return !/header/i.test(id) || d && d.closest('#shopify-section-' + id); }).slice(0, 5);
      if (!ids.length) return Promise.resolve();
      return fetch(location.pathname + '?sections=' + encodeURIComponent(ids.join(',')), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : {}; })
        .then(function (map) {
          ids.forEach(function (id) {
            if (!map[id]) return;
            var target = document.getElementById('shopify-section-' + id);
            var fresh = new DOMParser().parseFromString(map[id], 'text/html').getElementById('shopify-section-' + id);
            if (target && fresh) target.innerHTML = fresh.innerHTML;
          });
        }).catch(function () {});
    }

    function addToCart(variantId, btn, msg, box) {
      btn.disabled = true; btn.textContent = 'Adding…'; msg.textContent = '';
      var aose = cfg.afterAdd === 'drawer' ? aoseCart() : null;
      var drawer = themeDrawer();
      var dawn = !aose && isDawnDrawer(drawer);
      var payload = { items: [{ id: variantId, quantity: 1 }] };
      if (aose) {
        payload = { id: variantId, quantity: 1, sections: aose.sections, sections_url: location.pathname };
      } else if (dawn) {                                   /* Dawn and Dawn-based themes: let the drawer render itself */
        try {
          payload.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
          payload.sections_url = location.pathname;
        } catch (e) { dawn = false; }
      }
      fetch(cfg.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (r) {
        return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'This mattress could not be added to the cart.'); return j; });
      }).then(function (added) {
        btn.textContent = 'Added to cart';
        if (!box.querySelector('[data-view-cart]')) box.insertBefore(h('a', { href: cfg.cartUrl, class: 'mq-btn mq-btn--outline', 'data-view-cart': '', text: 'View cart' }), msg);
        setTimeout(function () { btn.disabled = false; btn.textContent = btn.dataset.label; }, 2500);

        if (cfg.afterAdd === 'cart') { window.location.href = cfg.cartUrl; return; }
        if (cfg.afterAdd === 'none') return fetch('/cart.js').then(function (r) { return r.json(); }).then(updateCountBubbles);

        var item = added.items ? added.items[0] : added;
        if (aose) {
          /* Same update the theme's own Add to cart makes, so the mini cart and cart count refresh themselves */
          window.xoStore.set('xo-cart', function (st) {
            return Object.assign({}, st, {
              size: (st && st.size || 0) + 1, sections: added.sections || {}, item: added,
              addIdLoading: '', isAdded: true, variantId: String(variantId), productIdsForCartNotification: [String(added.id)]
            });
          })('xo-cart/addCartSuccess');
          window.xoModal.open('cart');
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            window.xoStore.set('xo-cart', function (st) { return Object.assign({}, st, { size: cart.item_count }); })('xo-cart/setCartSize');
            updateCountBubbles(cart);
          });
        }
        if (dawn) {
          if (added.items && added.items[0]) {
            var dawnShape = Object.assign({}, added.items[0], { sections: added.sections });
            drawer.classList.remove('is-empty');
            drawer.renderContents(dawnShape);       /* updates the drawer + cart icon and opens it */
          }
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(updateCountBubbles);
        }
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          updateCountBubbles(cart);
          announceCartChange(cart, item);
          var d = themeDrawer();
          /* Give theme listeners a moment; if the drawer didn't refresh itself, re-render it */
          setTimeout(function () {
            var opened = d && (d.hasAttribute('open') || d.classList.contains('active') || d.classList.contains('is-open') || d.getAttribute('aria-hidden') === 'false');
            (opened ? Promise.resolve() : rerenderSections(d)).then(function () {
              var d2 = themeDrawer();
              if (d2) openDrawer(d2);
              else window.location.href = cfg.cartUrl;   /* theme has no drawer: show the cart page */
            });
          }, 250);
        });
      }).catch(function (e) { btn.disabled = false; btn.textContent = btn.dataset.label; msg.textContent = e.message; });
    }

    /* ---------- Save every completed quiz to Google Sheets (via a Google Apps Script web app) ---------- */
    function answerText(id) {
      var a = answers[id];
      if (a === undefined) return '';
      return [].concat(a).map(function (v) { return labelFor(id, v); }).join(', ');
    }
    function saveToSheet(picks) {
      var url = String(cfg.sheetUrl || '').trim();
      if (!/^https:\/\/script\.google(usercontent)?\.com\//.test(url)) return;
      var lead = leadData || {};
      var row = {
        name: lead.name || '', phone: lead.phone || '', email: lead.email || '',
        size: answerText('size'), type: answerText('type'), feel: answerText('feel'),
        position: answerText('position'), budget: answerText('budget'),
        details: leadData ? 'Yes' : 'No',
        page: location.origin + location.pathname
      };
      [0, 1, 2].forEach(function (i) {
        var r = picks[i];
        row['match' + (i + 1)] = r ? (r.p.brand ? r.p.brand + ' ' : '') + r.p.title + (r.v ? ' (' + r.v.title + ')' : '') + ' ' + (r.v ? r.v.priceText : r.p.priceText) : '';
      });
      var key = JSON.stringify([row.name, row.phone, row.size, row.type, row.feel, row.position, row.budget]);
      if (key === lastSheetRow) return;
      lastSheetRow = key;
      try {
        /* text/plain + no-cors: a "simple" request that Apps Script accepts without extra setup */
        fetch(url, { method: 'POST', mode: 'no-cors', keepalive: true, headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify(row) });
      } catch (e) {}
    }

    function renderResults() {
      stage.appendChild(h('div', { class: 'mq-step' }, [h('h2', { class: 'mq-q', tabindex: '-1', text: 'Finding your matches…' })]));
      var timeout = new Promise(function (res) { setTimeout(function () { res([]); }, 6000); });
      Promise.race([store2Ready, timeout]).then(function (extra) {
        if (STEPS[step] !== 'results') return;
        stage.innerHTML = '';
        drawResults(extra || []);
        var t = stage.querySelector('.mq-q');
        if (t) t.focus({ preventScroll: true });
      });
    }

    function drawResults(extra) {
      var count = cfg.count || 3;
      var ranked = rank(answers, products.concat(extra));
      var picks = ranked.slice(0, count);
      var sheetPicks = function () { return picks; };
      var need = Math.min(Number(S2.min) || 0, count);
      var have = picks.filter(function (r) { return r.p.external; }).length;
      if (have < need) {
        ranked.filter(function (r) { return r.p.external && picks.indexOf(r) === -1; }).slice(0, need - have).forEach(function (r) {
          if (picks.length >= count) {
            for (var i = picks.length - 1; i >= 0; i--) { if (!picks[i].p.external) { picks.splice(i, 1); break; } }
          }
          picks.push(r);
        });
        picks.sort(function (x, y) { return ranked.indexOf(x) - ranked.indexOf(y); });
      }
      saveToSheet(sheetPicks());
      var wrap = h('div', { class: 'mq-step mq-results-step' }, [
        thanksName !== null ? h('p', { class: 'mq-thanks', role: 'status', text: 'Thanks' + (thanksName ? ', ' + thanksName : '') + '! Our sleep experts will contact you soon.' }) : null,
        h('h2', { class: 'mq-q', tabindex: '-1', text: picks.length ? 'Your perfect mattress matches' : 'No exact match yet' }),
        h('p', { class: 'mq-desc', text: picks.length
          ? 'Based on your answers, these mattresses from our range suit you best.'
          : 'We could not find a ' + (answers.type === 'spring' ? 'spring ' : answers.type === 'foam' ? 'foam ' : '') + 'mattress in ' + (answers.size || 'that') + ' size right now. Try a different size or type, or browse the full range.' })
      ]);

      if (picks.length) {
        var grid = h('div', { class: 'mq-results' });
        picks.forEach(function (r, i) {
          var p = r.p, v = r.v;
          var url = p.url + (v ? (p.url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + v.id : '');
          var price = h('p', { class: 'mq-prod__price' }, [v ? v.priceText : p.priceText]);
          var cmp = v ? v.compareText : p.compareText;
          if (cmp) price.appendChild(h('s', { text: cmp }));
          var why = h('ul', { class: 'mq-prod__why' });
          r.why.forEach(function (w) { why.appendChild(h('li', { text: w })); });
          var msg = h('p', { class: 'mq-msg', role: 'status' });
          var box = h('div', { class: 'mq-prod__actions' });
          var ext = p.external ? { target: '_blank', rel: 'noopener' } : {};
          if (p.external) {
            box.appendChild(h('a', { href: url, class: 'mq-btn', target: '_blank', rel: 'noopener', text: 'Shop on ' + (p.brand || 'our other store') }));
          } else {
            var buy = v || p.variants.filter(function (x) { return x.available; })[0];
            if (buy && buy.available) {
              var addLabel = v && answers.size ? 'Add ' + answers.size + ' to cart' : 'Add to cart';
            var addBtn = h('button', { type: 'button', class: 'mq-btn', text: addLabel, 'data-label': addLabel });
              addBtn.addEventListener('click', function () { addToCart(buy.id, addBtn, msg, box); });
              box.appendChild(addBtn);
            }
            box.appendChild(h('a', { href: url, class: 'mq-btn mq-btn--outline', text: 'View details' }));
          }
          box.appendChild(msg);
          grid.appendChild(h('article', { class: 'mq-prod' + (i === 0 ? ' is-best' : '') }, [
            i === 0 ? h('span', { class: 'mq-badge', text: r.fit !== 'above' ? 'Best match' : 'Closest match' }) : null,
            h('a', { href: url, class: 'mq-prod__img', tabindex: '-1', 'aria-hidden': 'true', target: ext.target || null, rel: ext.rel || null }, [p.image ? h('img', { src: p.image, alt: '', loading: 'lazy', width: '700', height: '700' }) : null]),
            h('div', { class: 'mq-prod__body' }, [
              p.brand ? h('p', { class: 'mq-prod__brand', text: p.brand }) : null,
              h('h3', { class: 'mq-prod__title' }, [h('a', { href: url, text: p.title, target: ext.target || null, rel: ext.rel || null })]),
              price,
              r.why.length ? why : null,
              r.note ? h('p', { class: 'mq-prod__note', text: r.note }) : null,
              box
            ])
          ]));
        });
        wrap.appendChild(grid);
      }

      wrap.appendChild(h('div', { class: 'mq-nav' }, [
        h('button', { type: 'button', class: 'mq-btn', text: 'Retake Quiz', on: { click: function () { answers = {}; thanksName = null; leadData = null; lastSheetRow = null; go(1); } } }),
        h('a', { href: cfg.browseUrl, class: 'mq-btn mq-btn--outline', text: 'View all mattresses' })
      ]));

      if (cfg.designMode) {
        var count2 = function (list, k) { return list.filter(function (p) { return p.kind === k; }).length; };
        wrap.appendChild(h('p', { class: 'mq-admin', text: 'Only visible in the theme editor: this store ' + products.length + ' mattresses (' + count2(products, 'foam') + ' foam, ' + count2(products, 'spring') + ' spring); ' + (S2.name || 'second store') + ' ' + extra.length + ' (' + count2(extra, 'foam') + ' foam, ' + count2(extra, 'spring') + ' spring).' }));
      }
      stage.appendChild(wrap);
    }

    /* ---------- Lead form (optional) ---------- */
    if (leadForm) {
      var toResults = function () { go(STEPS.indexOf('results')); };
      var skipBtn = leadForm.querySelector('[data-lead-skip]');   /* removed from the section; kept optional */
      if (skipBtn) skipBtn.addEventListener('click', function () { leadData = null; toResults(); });
      leadForm.querySelector('[data-lead-back]').addEventListener('click', function () { go(step - 1); });
      /* Send the details without leaving the page.
         - Shopify's spam check (hCaptcha) re-submits the form by calling form.submit() once the visitor
           passes. We take over that call and send the form in the background, then read Shopify's reply.
         - Any other submit goes to a hidden frame, so the page itself never navigates.
         - The answers are also saved, so results come back even if a theme script forces a reload. */
      var frameName = 'mq-lead-frame-' + root.id;
      var frame = h('iframe', { name: frameName, title: 'Contact form', tabindex: '-1', 'aria-hidden': 'true', style: 'display:none' });
      root.appendChild(frame);
      leadForm.setAttribute('target', frameName);

      var sending = false, done = false, failTimer = null;
      var submitBtn = leadForm.querySelector('[type="submit"]');
      var submitLabel = submitBtn.textContent;
      var nameValue = function () { var n = leadForm.querySelector('[name="contact[name]"]'); return n ? n.value.trim() : ''; };

      var showLeadError = function (text) {
        var box = leadForm.querySelector('.mq-lead-error');
        if (!box) { box = h('div', { class: 'mq-lead-error', role: 'alert', 'data-lead-error': '' }); leadForm.insertBefore(box, leadForm.querySelector('.mq-fields')); }
        box.textContent = text;
        sending = false; clearTimeout(failTimer);
        submitBtn.disabled = false; submitBtn.textContent = submitLabel;
      };
      var finishLead = function () {
        if (done) return;
        done = true; sending = false; clearTimeout(failTimer);
        try { sessionStorage.removeItem(PENDING_KEY); } catch (e) {}
        thanksName = nameValue();
        submitBtn.disabled = false; submitBtn.textContent = submitLabel;
        toResults();
      };

      /* Background send, used when the spam check calls form.submit() */
      leadForm.submit = function () {
        fetch(leadForm.action, {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'text/html' },
          body: new URLSearchParams(new FormData(leadForm)).toString()   /* same encoding as a normal form */
        })
          .then(function (r) { return r.text().then(function (html) { return { url: r.url || '', html: html }; }); })
          .then(function (res) {
            var doc = new DOMParser().parseFromString(res.html, 'text/html');
            var err = doc.querySelector('[data-lead-error]');
            if (err && !/contact_posted=true/.test(res.url)) showLeadError(err.textContent.trim().replace(/\s+/g, ' '));
            else finishLead();
          })
          .catch(function () { finishLead(); });
      };

      /* Native submit into the hidden frame (the frame's page can't be read, so a finished load counts as sent) */
      frame.addEventListener('load', function () { if (sending) finishLead(); });

      leadForm.addEventListener('submit', function () {
        if (done) return;
        leadForm.querySelector('[data-lead-body]').value = 'Mattress quiz answers:\n' + summary();
        var fieldVal = function (n) { var el = leadForm.querySelector('[name="contact[' + n + ']"]'); return el ? el.value.trim() : ''; };
        leadData = { name: fieldVal('name'), phone: fieldVal('phone'), email: fieldVal('email') };
        try {
          sessionStorage.setItem(PENDING_KEY, JSON.stringify({ answers: answers, name: nameValue(), lead: leadData, t: Date.now() }));
        } catch (e) {}
        var old = leadForm.querySelector('.mq-lead-error');
        if (old) old.remove();
        sending = true;
        setTimeout(function () { submitBtn.disabled = true; submitBtn.textContent = 'Sending…'; }, 0);
        /* If the spam check is still showing a puzzle, wait; otherwise move on after 20 seconds */
        clearTimeout(failTimer);
        failTimer = setTimeout(function () { if (sending && !document.querySelector('iframe[src*="hcaptcha"][style*="visibility: visible"]')) finishLead(); }, 20000);
      });
    }

    /* ---------- Start: reopen results after the contact form reloads the page ---------- */
    var pending = null;
    try { pending = JSON.parse(sessionStorage.getItem(PENDING_KEY) || 'null'); } catch (e) {}
    var posted = !!root.querySelector('[data-lead-ok]') || /[?&]contact_posted=true/.test(location.search);
    var hadError = !!root.querySelector('[data-lead-error]');
    if (pending && pending.answers && Date.now() - pending.t < 30 * 60 * 1000 && (posted || hadError)) {
      answers = pending.answers;
      if (hadError && leadForm) {
        go(STEPS.indexOf('lead'));              /* show the form again with Shopify's error message */
      } else {
        try { sessionStorage.removeItem(PENDING_KEY); } catch (e) {}
        thanksName = pending.name || '';
        leadData = pending.lead || null;
        go(STEPS.indexOf('results'));
      }
      setTimeout(function () { root.querySelector('.mq-card').scrollIntoView({ block: 'start' }); }, 50);
    } else {
      go(0);
    }
  }

  function initAll(scope) {
    if (window.self !== window.top) return;
    var roots = (scope || document).querySelectorAll('[data-mattress-quiz]');
    Array.prototype.forEach.call(roots, initQuiz);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  /* Theme editor: re-run when the section is added or its settings change */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  window.MattressQuiz = { init: initQuiz };
})();